<template>
  <header id="header">
    <div class="sscontainer">
      <div class="menu-block">
        <logo-lien-header></logo-lien-header>
      </div>
      <div class="menu-block">
        <div class="menu-icons">
          <menu-header-profil v-if="userSelected"></menu-header-profil>
          <!--menu-header-recherche v-if="!isPro"></menu-header-recherche-->
          <menu-header-chat></menu-header-chat>
        </div>
        <div class="menu-icons" style="padding: 8px">
          <profile-picture></profile-picture>
          <div class="menu-name">{{ user ? user.first_name + ' ' + user.name : '' }}</div>
          <menu-header-signout></menu-header-signout>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header-registration',
  data() {
    return {
      user: {
        SrcPhotoUser: '',
      },
    }
  },
}
</script>
